// API基础URL
export const BASE_API = '/prod-api/lanyue-website';

// 项目名称
export const PROJECT_NAME = '蓝悦官网';
